import { FormControl, InputLabel, MenuItem, OutlinedInput, Select, SelectChangeEvent } from "@mui/material";
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import React, { FC } from "react";
import { InputParameters } from "../InputParameters";
import theme from "src/theme/light";
import { ComponentUtil } from "src/framework/commons/ComponentUtil";

export interface renderValue {
  (value: any): any;
}

export interface InputSelectSimpleProperties extends InputParameters {
  list: any;
  value: any;
  label: React.ReactNode;
  multiple?: boolean;
  id?: string;
  labelId?: string;
  variant?: "filled" | "outlined" | "standard";
  renderValue?: renderValue;
  allowNull?: boolean;
  onIconClick?: () => void;
  iconAdornment?: React.ReactNode;

  onChange(value: any): void;
}

const useStyles = makeStyles((_theme) =>
  createStyles({
    iconWrapper: {
      position: "absolute",
      right: 36,
      top: "50%",
      transform: "translateY(-50%)",
      zIndex: 2,
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
    },
    formControl: {
      position: "relative",
    },
    outlinedInput: {
      textAlign: "left",
    },
    selectAdornment: {
      marginRight: theme.spacing(3),
    },
  })
);

const InputSelectSimple: FC<InputSelectSimpleProperties> = (
  props: InputSelectSimpleProperties
) => {
  const classes = useStyles();

  const list = JSON.parse(JSON.stringify(props.list));
  const name = props.name ? props.name : JSON.stringify(props.list);

  const _props = { ...props };

  _props.variant = props.variant ? props.variant : "outlined";
  _props.size = props.size ? props.size : "small";
  _props.margin = props.margin ? props.margin : "normal";
  _props.fullWidth = props.fullWidth ? props.fullWidth : true;
  _props.error = props.error ? props.error === true : false;
  _props.allowNull = props?.allowNull ? props?.allowNull : false;
  _props.id = props.id ? props.id : ComponentUtil.keyGen(name);
  _props.labelId = props.labelId
    ? props.labelId
    : ComponentUtil.keyGen("label-" + name);

  const handleChange = (event: SelectChangeEvent<string>): void => {
    if (props.onChange) {
      const value = event.target.value as string;
      props.onChange(value);
    }
  };

  return (
    <FormControl
      error={_props.error}
      variant={_props.variant}
      size={_props.size}
      fullWidth={_props.fullWidth}
      margin={_props.margin}
      style={{ textAlign: "left" }}
      disabled={_props.disabled ? _props.disabled : false}
    >
      <InputLabel id="label-unidade-tempo-garantia" shrink={true}>{_props.label}</InputLabel>
      <Select
        ref={_props?.ref}
        labelId={_props.labelId}
        id={_props.id}
        value={props.value}
        onChange={handleChange}
        label={_props.label}
        name={name}
        error={_props.error}
        input={<OutlinedInput label={_props.label} classes={{ input: classes.outlinedInput }} />}
        onBlur={(event: any) => _props.onBlur?.(event)}
      >
        {_props.allowNull && (
          <MenuItem value="">
            <em>Nenhum</em>
          </MenuItem>
        )}
        {list.map((item: any) => {
          return (
            <MenuItem
              value={item.value}
              key={ComponentUtil.keyGen(`${name}-${item.value}`)}
              selected={item.value === props.value}
              disabled={item.disabled || false}
            >
              {item.text}
            </MenuItem>
          );
        })}
      </Select>

      {props.iconAdornment && props.onIconClick && (
        <div
          className={classes.iconWrapper}
          onClick={(e) => {
            e.stopPropagation();
            props.onIconClick?.();
          }}
        >
          {props.iconAdornment}
        </div>
      )}
    </FormControl>
  );
};

export { InputSelectSimple };
